import { useCallback } from 'react';

import {
  hapticError,
  hapticImpact,
  hapticSelection,
  hapticSuccess,
  hapticWarning,
} from '@/lib/haptic';
import { useToast } from '@/providers/ToastProvider';

export function useFeedback(): {
  tap: () => void;
  select: () => void;
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
} {
  const toast = useToast();

  const tap = useCallback(() => {
    hapticImpact('light');
  }, []);

  const select = useCallback(() => {
    hapticSelection();
  }, []);

  const success = useCallback(
    (message: string) => {
      hapticSuccess();
      toast.success(message);
    },
    [toast],
  );

  const error = useCallback(
    (message: string) => {
      hapticError();
      toast.error(message);
    },
    [toast],
  );

  const warning = useCallback(
    (message: string) => {
      hapticWarning();
      toast.warning(message);
    },
    [toast],
  );

  return { tap, select, success, error, warning };
}
